// extracted by mini-css-extract-plugin
export default {"buttons":"submit-button_buttons__baquz"};